// extracted by mini-css-extract-plugin
module.exports = {"input":"basicInformation_input__3eRn9"};